module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-content"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f2b083a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/PanelContent/index.vue
// module id = 731
// module chunks = 3